import { CustomComponentProps, useFormNav } from '@updater/ui-informant';
import { Box } from '@updater/ui-uds';
import { AddressWidget } from '@updater/ui-widgets';
import { useRef } from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const FromAddressContainer = styled(Box)`
  position: relative;
  display: block;
`;

export const Mask = styled(Box)`
  width: 100%;
  height: 100%;
  &.fadeIn {
    animation: ${keyframes`0% { opacity: 0; } 100% { opacity: 1; }`} 400ms
      ease-out;
  }
`;

export const FromUsaAddress: React.FC<CustomComponentProps> = (props) => {
  const { schema, name } = props;
  const componentProps = schema.ui?.componentProps ?? {};
  const { goNext } = useFormNav();
  const renderCount = useRef(0);
  renderCount.current = renderCount.current + 1;
  return (
    <FromAddressContainer>
      <Mask className={`${renderCount.current > 1 && 'fadeIn'}`}>
        <AddressWidget
          {...componentProps}
          name={name}
          onComplete={() => goNext()}
        />
      </Mask>
    </FromAddressContainer>
  );
};
